import { requireGuest } from "@/features/auth";
import { type AuthSearch, guestRedirectFor, validateAuthSearch } from "@/features/auth/auth-search";
import { Outlet, createFileRoute } from "@tanstack/react-router";

// Check ./signup/index.ts for route
export const Route = createFileRoute("/signup")({
  validateSearch: (search): AuthSearch => validateAuthSearch(search),
  beforeLoad: async ({ search }) => {
    await requireGuest(guestRedirectFor(search));
  },
  component: Outlet,
});
